import { joinClassNames, WithChildren } from '@vertex-protocol/web-common';
import { ThemeName } from '@vertex-protocol/web-ui';
import { FONTS } from 'common/theme/fonts';

export function AppRootLayout({ children }: WithChildren) {
  const currentTheme: ThemeName = 'arcaLight';

  return (
    <html
      lang="en"
      className={joinClassNames(
        FONTS.default.className,
        FONTS.default.variable,
        FONTS.title.variable,
        FONTS.mono?.variable,
        'overscroll-none antialiased',
      )}
      data-theme={currentTheme}
    >
      <body className="bg-background text-text-secondary overscroll-none">
        {children}
      </body>
    </html>
  );
}
